import React from 'react';
import { useSelector } from 'react-redux';
import colors from '../../utils/colors';

const SubmissionStatus = ({value}) => {
  const { submissionStatusById, language = {} } = useSelector(state => state.system)

  return <>{
    submissionStatusById[value] ? (
      <span style={{color: colors.submission[value]}}>
        {submissionStatusById[value].name[language.name]}
      </span>
    ) : value === 'under_review' ? (
      <span style={{color: '#EAA800'}}>Under Review</span>
    ) : value === 'approved' ? (
      <span style={{color: colors[4]}}>Approved</span>
    ) : (
      <span className="text-gray-999">{String(value)}</span>
    )
  }</>
}

export { SubmissionStatus }
